import { CatchmentDTO } from './CatchmentDTO'
import { CatchmentRaw } from './CatchmentRaw'
import { LevelOfDetailDTOFactory } from './LevelOfDetailDTOFactory'

export class CatchmentDTOFactory {
  static fromRaw(raw: CatchmentRaw): CatchmentDTO {
    return new CatchmentDTO(raw.lods.map(LevelOfDetailDTOFactory.fromRaw))
  }
}
